module.exports = __webpack_public_path__ + "static/meteo_suisse-69ccae0a8180ba511e857c81e4daa334.jpg";